import { ItemList } from '../../orm'

class AdminCustomerMigrationLogList extends ItemList {
    getEntityKey() {
        return "admin/migration_customer_log"
    }
}

export const adminCustomerMigrationLogList = new AdminCustomerMigrationLogList("admin_customer_migration_log__default")
